import axios from "@/plugins/axios";

const emptyForm = {
  first_name: "",
  last_name: "",
  position: "",
  email: "",
  state: -1,
};

// initial state
const state = () => ({
  companies: [],
  filteredCompanies: [],
  selectedContacts: [],
  contactForm: emptyForm,
  editId: null,
  selectable: false,
  serviceFilter: "",
  loading: false,
  toasts: [],
});

const getters = {
  isSelectable: (state) => {
    return state.selectable;
  },
  isContactSelected: (state) => (contactId) => {
    return state.selectedContacts.indexOf(contactId) !== -1;
  },
  companyIsIndeterminate: (state) => (contacts) => {
    return contacts.some((c) => state.selectedContacts.includes(c.id));
  },
  companyContactsSelected: (state) => (contacts) => {
    if (contacts.length === 0) {
      return false;
    } else {
      return contacts.every((c) => state.selectedContacts.includes(c.id));
    }
  },
  isLoading: (state) => {
    return state.loading;
  },
  getToasts(state) {
    return state.toasts;
  },
  getSelectedContacts(state) {
    return state.selectedContacts;
  },
};

const actions = {
  async fetchContacts({ commit, state }) {
    commit("setIsLoading", true);
    let response = await fetch("/api/rest/admin/companyContacts");
    commit("setIsLoading", false);
    if (response.ok) {
      let contacts = await response.json();
      commit("setContacts", contacts);
      commit("filterContacts", state.serviceFilter);
    } else {
      alert("HTTP-Error: " + response.status);
    }
  },
  async addContact({ commit, state, dispatch }, contact) {
    try {
      await axios.post("/api/rest/admin/companyContacts", contact);
      commit("addToast", {
        message: "Contact added successfully",
        title: "Success",
        variant: "success",
      });
      dispatch("fetchContacts");
    } catch (err) {
      commit("addErrorToast", {
        errors: err.response.data.errors,
      });
    }
  },
  async removeContact({ commit, state, dispatch }, contact) {
    try {
      await axios.delete(`/api/rest/admin/companyContacts/${contact.id}`);
      commit("addToast", {
        message: "Contact removed successfully",
        title: "Success",
        variant: "success",
      });
      dispatch("fetchContacts");
    } catch (err) {
      commit("addErrorToast", {
        errors: err.response.data.errors,
      });
    }
  },
  async getContact({ commit, state }, contact) {
    try {
      let response = await axios.get(`/api/rest/admin/companyContacts/${contact.id}`);
      commit("setContactForm", response.data[0]);
    } catch (err) {
      commit("addErrorToast", {
        errors: err.response.data.errors,
      });
    }
  },
  async editContact({ commit, state, dispatch }, contact) {
    try {
      await axios.patch(`/api/rest/admin/companyContacts/${contact.id}`, contact);
      commit("addToast", {
        message: "Contact updated successfully",
        title: "Success",
        variant: "success",
      });
      dispatch("fetchContacts");
    } catch (err) {
      commit("addErrorToast", {
        errors: err.response.data.errors,
      });
    }
  },
  setFilter({ commit }, filter) {
    commit("filterContacts", filter);
  },
  selectAllContacts({ commit, state }) {
    let allContacts = [];
    state.filteredCompanies.map((company) => {
      allContacts = allContacts.concat(company.contacts);
    });
    commit("selectContacts", allContacts);
  },
  removeAllContacts({ commit, state }) {
    let allContacts = [];
    state.filteredCompanies.map((company) => {
      allContacts = allContacts.concat(company.contacts);
    });
    commit("removeSelections", allContacts);
  },
};

const mutations = {
  setContacts(state, contacts) {
    state.companies = contacts;
  },
  filterContacts(state, filter) {
    state.serviceFilter = filter;
    if (state.serviceFilter !== "") {
      state.filteredCompanies = state.companies.filter((company) =>
        company.services.includes(state.serviceFilter)
      );
    } else {
      state.filteredCompanies = state.companies;
    }
  },
  removeContact(state, contact) {
    let company = state.companies.find((c) => c.id === contact.company_id);
    company.companies.filter((c) => c.id !== contact.id);
  },
  setContactForm(state, form) {
    state.contactForm = form;
    let company = state.companies.find((c) => c.id === form.company_id);
    state.editId = company.id;
  },
  clearContactForm(state) {
    state.contactForm = emptyForm;
    state.editId = null;
  },
  clearSelectedContacts(state) {
    state.selectedContacts = [];
  },
  setSelectable(state, selectable) {
    state.selectable = selectable;
  },
  selectContacts(state, contacts) {
    contacts.map((contact) => {
      if (state.selectedContacts.indexOf(contact.id) === -1) {
        state.selectedContacts.push(contact.id);
      }
    });
  },
  removeSelections(state, contacts) {
    let updatedContacts = state.selectedContacts;
    contacts.map((contact) => {
      updatedContacts = updatedContacts.filter((c) => c !== contact.id);
    });
    state.selectedContacts = updatedContacts;
  },
  toggleSelections(state, contacts) {
    let updatedContacts = state.selectedContacts;
    contacts.map((contact) => {
      if (updatedContacts.indexOf(contact.id) === -1) {
        updatedContacts.push(contact.id);
      } else {
        updatedContacts = updatedContacts.filter((c) => c !== contact.id);
      }
    });
    state.selectedContacts = updatedContacts;
  },
  setIsLoading(state, loadState) {
    state.loading = loadState;
  },
  addToast(state, payload) {
    state.toasts.push({
      message: payload.message,
      options: {
        title: payload.title ? payload.title : "Toast",
        variant: payload.variant ? payload.variant : "info",
        autoHideDelay: 3000,
        appendToast: true,
      },
    });
  },
  addErrorToast(state, payload) {
    const message = payload.errors[Object.keys(payload.errors)[0]][0];
    state.toasts.push({
      message: message,
      options: {
        title: "Error",
        variant: "danger",
        autoHideDelay: 3000,
        appendToast: true,
      },
    });
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
